import React, { useEffect } from 'react';
import { useLayer } from '../../hooks/useLayer';
import { styleFactory } from '../../utils/styleFactory';
export const FeatureStyle = React.memo(({ layerId, featureIds, style }) => {
    const layer = useLayer(layerId);
    useEffect(() => {
        if (!layer || !style)
            return;
        const styleInstance = styleFactory(style);
        const originalStyles = new Map();
        const source = layer.getSource();
        for (const featureId of featureIds) {
            if (featureId) {
                let feature = source.getFeatureById(featureId);
                if (!feature) {
                    feature =
                        source.getFeatures().find((feature) => feature.get('id') === featureId) ?? null;
                }
                if (feature) {
                    originalStyles.set(feature, feature.getStyle());
                    feature.setStyle(styleInstance);
                }
            }
        }
        return () => {
            for (const [feature, originalStyle] of originalStyles.entries()) {
                feature.setStyle(originalStyle);
            }
        };
        // eslint-disable-next-line
    }, [layer, style, featureIds.join()]);
    return null;
});
//# sourceMappingURL=FeatureStyle.js.map